export const CONTANTS = {
  SITE: "Tài chính cá nhân | CaNhanf.com",
  SITE_SHORT: "CaNhanf.com",
  FB_APP_ID: "1391515398495134",
  FB_CLIENT: "1c18f04699fd2120f72363eb1a18635f",
  // FB_APP_ID: '2626546210969129', // Temp
  GOOGLE_SITE_VERIFY: "Yf9ovRqTCSfcu618eMVGlkg8rVcvY-NQsurMPJnOsNE",
  BING_SITE_VERIFY: "93AB4892DD510B44E22202F8221450AA",
  FB_SITE_VERIFY: "ff8l85dp63m39mtjyi6580k0yflzsu",
  FB_PAGE_ID: "110711128371397",
  // GTAG: 'G-0S8WMH81HR', Old one
  // GTAG: "G-733FGJFX0E", // new one account cafeboss405gmail
  GTAG: "GTM-NC8CM63D",

  // gmail: binh ctk28
  GG_APP_API_KEY: "AIzaSyBYMMHDh82TrRfmJ97SVaDMDf9e1fDFFfU",
  GG_CLIENT_ID:
    "854011740201-ietah59um4pq6ps6f7uksru63s4ekhev.apps.googleusercontent.com",
  GG_CLIENT_Secret: "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",

  USER_SIGNIN_COOKIE: "cookie.USERS",

  ACCOUNT_CATEGORY: {
    cash: "Tài khoản tiền mặt",
    invest: "Tài khoản đầu tư",
    liability: "Tài khoản nợ",
    wallet: "Ví điện tử",
  },

  LENDING_RECEIVE_TYPE: [
    { value: "card", label: "Nhận tiền chuyển khoản" },
    { value: "cash", label: "Nhận tiền mặt" },
  ],

  DEFAULT_DIAGRAM: {
    1: [1, 2, 3, 4, 5],
    2: [6, 7, 8, 9, 10],
    3: [11, 12, 13, 14, 15],
    4: [16, 17, 18, 19, 20],
  },

  CAR_PURCHASE_STATUS: {
    contact: "Tiếp nhận thông tin",
    confirm: "Xác minh giấy tờ",
    contract: "Ký hợp đồng",
    bug: "Xử lý sự cố",
    complete: "Kết thúc hợp đồng",
  },

  CAR_COST_TYPE: [
    {
      category: "car.cost.initial",
      total_income: 0,
      total_cost: 0,
      name: "Chi phí ban đầu",
    },
    {
      category: "car.cost.activity",
      total_income: 0,
      total_cost: 0,
      name: "Chi phí đầu tư, mua thêm",
    },
    {
      category: "car.cost.energy",
      total_income: 0,
      total_cost: 0,
      name: "Chi phí nhiên liệu đổ xăng",
    },
    {
      category: "car.cost.repair",
      total_income: 0,
      total_cost: 0,
      name: "Chi phí sửa chữa bảo trì",
    },
  ],

  CAFE_COST_TYPE: [
    {
      category: "cafe.cost.cafe",
      total_income: 0,
      total_cost: 0,
      name: "Cà phê",
    },
    {
      category: "cafe.cost.milk",
      total_income: 0,
      total_cost: 0,
      name: "Sữa đặc",
    },
    {
      category: "cafe.cost.freshmilk",
      total_income: 0,
      total_cost: 0,
      name: "Sữa tươi",
    },
    {
      category: "cafe.cost.softdrink",
      total_income: 0,
      total_cost: 0,
      name: "Nước ngọt",
    },
    {
      category: "cafe.cost.sugar",
      total_income: 0,
      total_cost: 0,
      name: "Đường",
    },
    { category: "cafe.cost.box", total_income: 0, total_cost: 0, name: "Hộp" },
    { category: "cafe.cost.ice", total_income: 0, total_cost: 0, name: "Đá" },
    {
      category: "cafe.cost.fruit",
      total_income: 0,
      total_cost: 0,
      name: "Trái cây",
    },
    {
      category: "cafe.cost.other",
      total_income: 0,
      total_cost: 0,
      name: "Khác",
    },
    {
      category: "cafe.cost.place",
      total_income: 0,
      total_cost: 0,
      name: "Mặt bằng, điện nước",
    },
    {
      category: "cafe.cost.employee",
      total_income: 0,
      total_cost: 0,
      name: "Lương NV",
    },
  ],

  COST_BY_CATEGORY: [
    {
      category: "income.salary",
      total_income: 0,
      total_cost: null,
      name: "Thu nhập từ lương",
    },
    {
      category: "income.invest",
      total_income: 0.0,
      total_cost: null,
      name: "Thu nhập đầu tư, cho thuê",
    },
    {
      category: "income.other",
      total_income: 0.0,
      total_cost: null,
      name: "Thu nhập khác",
    },
    { category: "family", total_income: null, total_cost: 0, name: "Gia đình" },
    {
      category: "family.home",
      total_income: null,
      total_cost: 0,
      name: "Nhà cửa",
    },
    {
      category: "family.gift",
      total_income: null,
      total_cost: 0.0,
      name: "Biếu tặng",
    },
    {
      category: "family.children",
      total_income: null,
      total_cost: 0.0,
      name: "Con cái",
    },
    {
      category: "person.food",
      total_income: null,
      total_cost: 0.0,
      name: "Ăn uống",
    },
    {
      category: "person.cafe",
      total_income: null,
      total_cost: 0.0,
      name: "Giải trí",
    },
    {
      category: "person.tax",
      total_income: null,
      total_cost: 0,
      name: "Thuế cá nhân",
    },
    {
      category: "cost.paper",
      total_income: null,
      total_cost: 0,
      name: "Hành chính",
    },
    {
      category: "cost.other",
      total_income: null,
      total_cost: 0,
      name: "Chi phí khác",
    },
  ],

  USER_PLAN: {
    free: "Miễn phí",
    monthly: "Hàng tháng",
    haft: "6 tháng",
    yearly: "Hàng năm",
  },

  MENU_CATEGORY: {
    coffee: "Cà phê",
    yaourt: "Yaourt",
    juice: "Nước trái cây",
    vitamin: "Sinh tố (theo mùa)",
    tea: "Trà",
    drink: "Nước ngọt",
    other: "Khác",
  },

  COFFEE_COST_TYPE: [
    {
      category: "cafe.cost.cafe",
      total_income: 0,
      total_cost: 0,
      name: "Cà phê",
    },
    {
      category: "cafe.cost.milk",
      total_income: 0,
      total_cost: 0,
      name: "Yaourt",
    },
    {
      category: "cafe.cost.fruit",
      total_income: 0,
      total_cost: 0,
      name: "Nước trái cây",
    },
    {
      category: "cafe.cost.freshmilk",
      total_income: 0,
      total_cost: 0,
      name: "Sinh tố (theo mùa)",
    },
    {
      category: "cafe.cost.ice",
      total_income: 0,
      total_cost: 0,
      name: "Trà",
    },
    {
      category: "cafe.cost.softdrink",
      total_income: 0,
      total_cost: 0,
      name: "Nước ngọt",
    },
    {
      category: "cafe.cost.other",
      total_income: 0,
      total_cost: 0,
      name: "Khác",
    },
  ],

  LIMIT_CATEGORY_FREE: 5,
  LIMIT_CATEGORY_ALL: 20,
  LIMIT_PRODUCT_UNIT_FREE: 5,
  LIMIT_PRODUCT_UNIT_ALL: 20,
  LIMIT_PRODUCT_FREE: 5,
  LIMIT_PRODUCT_ALL: 100,
};

export const CONTANTS_EN = {
  USER_PLAN: {
    free: "Free",
    monthly: "Monthly",
    haft: "6 months",
    yearly: "Yearly",
  },

  POLAR_PLAN: {
    monthly: "Monthly",
    six_month: "6 months",
    yearly: "Yearly",
  },
};
